//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import parse from 'date-fns/parse'
import format from 'date-fns/format'

import slugify from 'slugify';

export default {
  props: ['activeModal'],
  computed: {

  },
  watch: {
      activeModal(nV) {

          if ( nV ) {
              let modal = `menu-${nV.acf_fc_layout}-modal`;
              this.$modal.show(modal);
          }

      }
  },
  components: {

  },
  data() {
    return { 
      
        modalOpen: false,
        sliderOptions: {
            initialIndex: 0,
            wrapAround: true,
            resize: true,
            setGallerySize: false
            // any options from Flickity can be used
        },
        blocks: menu_blocks
     
    }
  },
  mounted() {



  },
  methods: {
    closeModal(modal) {
        this.$modal.hide(modal);
    },
    closedModal() {
        this.modalOpen = false;
        this.$root.$emit('closeModal');
    }
  }
}




// WEBPACK FOOTER //
// ./scripts/components/MenuModals.vue